import { ca } from '@cian/analytics';
import { getEventCategoryFromPageKind } from '../../utils/tracking';
import { EPageKind } from '../../types/page';

export const trackGeoSwitcherClick = (pageKind: EPageKind, label?: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: getEventCategoryFromPageKind(pageKind),
    action: 'top_geo_click',
    label,
  });
};

export const trackGeoSwitcherSelect = (pageKind: EPageKind, label?: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: getEventCategoryFromPageKind(pageKind),
    action: 'top_geo_select',
    label,
  });
};
